"use client";

import { createContext, PropsWithChildren, useContext } from "react";
import { IInterval } from "../../types";

export interface ChartContextType {
  chartId: string;
  chartType: "funnel" | "linear" | "metric" | "line";
  previous?: any;
  previousIndicatorInverted?: boolean;
  interval: IInterval;
  data: any | any[];
  format?: string;
}

export interface ChartProviderProps
  extends ChartContextType,
    PropsWithChildren {}

const ChartContext = createContext<ChartContextType | null>(null);

export function ChartProvider({ children, ...props }: ChartProviderProps) {
  return (
    <ChartContext.Provider value={props}>{children}</ChartContext.Provider>
  );
}

export function useChartContext() {
  return useContext(ChartContext)!;
}
